import styled, { DefaultTheme } from "styled-components";

type Themed = { theme: DefaultTheme };
const desktop = ({ theme }: Themed) => `min-width: ${theme.screens.l.min}`;

export const Container = styled.div`
  display: block;
`;
